import React from 'react';
import './App.css';
import SmartContractUI from './SmartContractUI';

function App() {
  return (
    <div className="App">
      <SmartContractUI />
    </div>
  );
}

export default App;